import moment from 'moment';

// Assume (guess?) that we'll have a two-minute overhead for things like daemon polling, task
// assignment, startup, teardown, etc.
const PROCESSING_OVERHEAD_MS = 2 * 60 * 1000;

const estimatePreProcessingTimeRemaining = (broadcast) => {
  // Assume (guess?) that we'll have a two-minute overhead, followed by a transcode that
  // matches the broadcast duration
  const broadcastDurationMs =
    moment(broadcast.stops_at).toDate().getTime() - moment(broadcast.starts_at).toDate().getTime();
  return PROCESSING_OVERHEAD_MS + broadcastDurationMs;
};

const estimateCurrentProcessingTimeRemaining = (broadcast, upload, now) => {
  // If we're processing, balance the duration estimate with one based on the upload creation
  // time and completion percentage.
  const progressPercent = upload.progress || 0.0;

  // First, the estimate based on broadcast duration and percentage remaining
  const broadcastDurationMs =
    moment(broadcast.stops_at).toDate().getTime() - moment(broadcast.starts_at).toDate().getTime();
  const broadcastDurationEstimateMs = (broadcastDurationMs * (100.0 - progressPercent)) / 100.0;

  // Next, the estimate based on upload creation time and progress (if possible)
  let uploadProgressEstimateMs = null;
  if (progressPercent > 0.0) {
    if (upload.created_at) {
      const uploadCreatedAt = moment(upload.created_at).toDate().getTime();
      if (now > uploadCreatedAt) {
        const elapsed = now - uploadCreatedAt;
        const estimatedTotalDuration = (elapsed * 100.0) / progressPercent;
        const estimatedCompletion = uploadCreatedAt + estimatedTotalDuration;
        uploadProgressEstimateMs = estimatedCompletion - now;
      }
    }
  }
  if (!uploadProgressEstimateMs) {
    // If this is null, just set it to broadcastDurationEstimateMs because progressPercent is
    // likely zero and the math is a wash
    uploadProgressEstimateMs = broadcastDurationEstimateMs;
  }

  // Calculate a weighted average of our two estimates (based on percentage complete)
  return (
    (broadcastDurationEstimateMs * (100.0 - progressPercent)) / 100.0 +
    (uploadProgressEstimateMs * progressPercent) / 100.0
  );
};

/**
 * Estimate the amount of processing (transcoding) time remaining (in milliseconds) for a broadcast
 * with an upload.
 *
 * @param  {Object} opts An object containing the keys:
 *                       - broadcast: The broadcast object
 *                       - upload: The upload object
 * @return {Number}      The estimated processing time remaining, in milliseconds, or null if the
 *                       arguments don't make sense.
 */
export function estimateProcessingTimeRemaining(opts) {
  const broadcast = opts.broadcast;
  const upload = opts.upload;
  if (!broadcast || !upload) {
    return null;
  }

  if (upload.status == 'uploaded' || upload.status == 'assigned') {
    return estimatePreProcessingTimeRemaining(broadcast);
  }

  if (upload.status == 'processing') {
    const now = opts.now || Date.now();
    return estimateCurrentProcessingTimeRemaining(broadcast, upload, now);
  }

  // Catch-all
  return null;
}



// WEBPACK FOOTER //
// ./app/utils/uploads.js